const firstValue = (value) => {
  if (Array.isArray(value)) return value[0];
  return value;
};

export const getApiErrorMessage = (error, fallbackMessage) => {
  if (Array.isArray(error)) {
    return (
      firstValue(error[0]?.description_es) ||
      firstValue(error[0]?.description) ||
      firstValue(error[0]?.message) ||
      fallbackMessage
    );
  }

  const errorData = error?.errors || error?.response?.data?.errors || error;

  return (
    firstValue(errorData?.description_es) ||
    firstValue(errorData?.description) ||
    firstValue(errorData?.message) ||
    firstValue(error?.response?.data?.description_es) ||
    firstValue(error?.response?.data?.description) ||
    firstValue(error?.message) ||
    fallbackMessage
  );
};
